module.exports = __webpack_public_path__ + "static/img/moreindustry2.f3981773.png";